import React, { useEffect } from "react";
import { Link } from "react-router-dom"; // Assuming you're using React Router
import "./NotFoundPage.css";
const NotFoundPage = () => {
  useEffect(() => {
    document.title = "404 - Page Not Found | YourSiteName";
    window.history.replaceState(null, "", "/404");
  }, []);

  return (
  <>
   <div className="not-found-page">
      <section className="not-found-container">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>Sorry, the page you are looking for does not exist.</p>
        <Link to="/" className="go-home-btn">
          Go to Home
        </Link>
      </section>
    </div>
  </>
  );
};

export default NotFoundPage;
